import React from 'react';

// Shared "well done" popup (Style C) rendered by every game on success.
function MascotCelebration({ quote, onReplay, replayLabel = 'دوبارہ کھیلیں', overlay = true, title }) {
  const content = (
    <div className="mascot-container">
      {title && <p className="celebration-title">{title}</p>}
      <img src={`${process.env.PUBLIC_URL}/images/mascot.png`} alt="Mascot" className="celebration-mascot-icon" />
      <div className="celebration-bubble">{quote}</div>
      {onReplay && (
        <button className="mascot-replay-button" onClick={onReplay}>{replayLabel}</button>
      )}
    </div>
  );

  return overlay ? <div className="mascot-celebration-overlay">{content}</div> : content;
}

export default MascotCelebration;
